import { fetchRequestPrev } from "@providers/conect_prev";
import { fetchRequest } from "@providers/conect";

const verSaveCitaApi = async ( data ) => {

  try {
    const url = `integrations/previplan/agendar-cita`
    const response = await fetchRequestPrev(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const storeBoldApi = async ( data ) => {
  try {
    const url = `agendawp/store-bold`
    const response = await fetchRequest(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

/** Consulta oficina_bold_response por order_id (bold-order-id) y type SALE_APPROVED */
const validateBoldOrderApi = async (data) => {
  try {
    const url = `agendawp/validate-bold-order`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: { ...data },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { verSaveCitaApi, storeBoldApi, validateBoldOrderApi };
